import { useFormacao } from 'Common/Context/Formacao'
import React from 'react'
import styles from './Banner.module.css'
import serio from './serio.jpg'
import legal from './gif.gif'

export default function Banner({ titulo, imagem }) {
    const { modo } = useFormacao()

    return (
        <>
            {modo

                ? <div className={styles.banner} style={{ backgroundImage: `url(${serio})` }}>
                    <h2>{titulo}</h2>
                </div>

                : <div className={styles.banner} style={{ backgroundImage: `url(${legal})` }}>
                    <h2>{titulo}</h2>
                </div>
            }
        </>

    )
}
